import { render } from "./File.vue?vue&type=template&id=3c320cc1&scoped=true"
import script from "./File.vue?vue&type=script&lang=js"
export * from "./File.vue?vue&type=script&lang=js"

import "./File.vue?vue&type=style&index=0&id=3c320cc1&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c320cc1"],['__file',"src/assets/js/components/Form/File.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "3c320cc1"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('3c320cc1', __exports__)) {
    api.reload('3c320cc1', __exports__)
  }
  
  module.hot.accept("./File.vue?vue&type=template&id=3c320cc1&scoped=true", () => {
    api.rerender('3c320cc1', render)
  })

}


export default __exports__